import slideShow from "./slideshow/index";
import checkout from './checkout/index';
import voucher from "./voucher/index";
import Vuex from "vuex";
import Vue from "vue";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    checkout: checkout,
    voucher: voucher,
    slideShow: slideShow,
  }
})
